import { Modal, Divider, Button } from 'antd';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

// Local
import { logout } from 'modules/auth/actions';
import { resetEnv } from 'modules/ui/actions';
import { connect } from 'react-redux';
import { isPremium } from 'utils';

const StyledLi = styled.li`
  margin-bottom: 10px;

  > a, span {
    text-decoration: none !important;
    font-size: 15px !important;
    color: ${props => props.theme ? props.theme.linksColor : '#53b297'}  !important;
  }

  > a {
    &:hover {
      color: #13a9c6 !important;
    }
  }
`;

const StyledModal = styled(Modal)`
  button.ant-btn-primary {
    background: ${ props => props.theme.buttonColor} !important;
  }
`;

/**
 * MenuModal
 * @param {*} props 
 * @returns 
 */
const MenuModal = (props) => {
  return (
    <StyledModal 
      visible={props.visible}
      onOk={props.onOk}
      onCancel={props.onCancel}
      footer={null}
      theme={props.ui.theme}
    >
      <ul style={{ listStyleType: 'none' }}>
        <StyledLi theme={props.ui.theme}><Link to={`/home`} onClick={() => props.onOk()}>Accueil</Link></StyledLi>
        {
          isPremium(props.auth.tenant) && (
            <StyledLi theme={props.ui.theme}><Link to={'/configurator'} onClick={() => props.onOk()}>Impression sur support</Link></StyledLi>
          )
        }
        
        {
          props.ui.quotationBasket.length > 0 && (
            <StyledLi theme={props.ui.theme}><Link to={`/quotations`} onClick={() => props.onOk()}>Mes montages personnalisés</Link></StyledLi>
          )
        }

        {
          props.ui.mountQuotations.length > 0 && (
            <StyledLi theme={props.ui.theme}><Link to={`/mount-quotations`} onClick={() => props.onOk()}>Mes propositions de montages</Link></StyledLi>
          )
        }
        
        <StyledLi theme={props.ui.theme}><Link to={`/orders/history`} onClick={() => props.onOk()}>Mes commandes</Link></StyledLi>
        <StyledLi theme={props.ui.theme}><Link to={`/user`} onClick={() => props.onOk()}>Mon profil</Link></StyledLi>

        {
          isPremium(props.auth.tenant) && (
            <StyledLi theme={props.ui.theme}><Link to={`/helpdesk`} onClick={() => props.onOk()}>J'ai un problème</Link></StyledLi>
          )
        }
        
        <Divider />

        <Button onClick={() => {props.onCancel(); props.resetEnv()}} type="primary" size="small">Déconnexion</Button>
      </ul>
    </StyledModal>
  )
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui,
})

const dispatchToProps = {
  logout,
  resetEnv
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(MenuModal));